class RebuyRecommendation extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    new Swiper("[js-rebuy-recommendation-slider]", {
        slidesPerView: 4,         
        spaceBetween: 10,           
        pagination: {
          el: "[js-rebuy-recommendation-swiper-pagination]",
          type: "progressbar", 
        },
        breakpoints: {
            360: {                
              slidesPerView: 1.2,
              spaceBetween: 5,   
            }, 
            767: {                 
              slidesPerView: 2.5, 
              spaceBetween: 10,
            },
            1279: {                 
              slidesPerView: 4,
              spaceBetween: 10,  
            }
        } 
    });
  }
}

customElements.define('rebuy-recommendation', RebuyRecommendation);